export default __webpack_public_path__ + "static/ko-fi_logo-7b6a50c53af600499feb01a615d5e4fb.png";